import * as React from 'react';
export const IESvg = React.forwardRef(function IESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M5 2h6v12H5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M5 14v-1h6v1H5ZM5 2h6v1H5V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2 2h3v12H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79A59',
        d: 'M14 14h-3V2h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      }),
    ),
  );
});
IESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var IE = {
  category: 'flag',
  colorable: false,
  name: 'IE',
  svg: IESvg,
};
